import React from "react";
import Payment from "./components/Payment.jsx";

const FourthStep = () => {
  return (
    <div className="min-h-screen bg-[#0b0f17] text-slate-100">
      <Payment />
    </div>
  );
};

export default FourthStep;
